"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _HeaderArea = require("./HeaderArea");
Object.keys(_HeaderArea).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _HeaderArea[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _HeaderArea[key];
    }
  });
});
var _Olapic = require("./Olapic");
Object.keys(_Olapic).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Olapic[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _Olapic[key];
    }
  });
});
var _Products = require("./Products");
Object.keys(_Products).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Products[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _Products[key];
    }
  });
});
